import React from 'react';

import { CliveChipVariant } from '~/components/AiChat/CliveChip/CliveChip';
import { Heading } from '~/components/core';
import { MarkdownSection } from '~/components/core/MarkdownSection';
import { CardBase } from '~/components/core/NewDesignSystem/Cards/CardBase';
import cn from '~/Utils/cn';

import { CliveCopyToClipboardButton } from '../CliveCopyToClipboardButton';
import { CliveStoreProcessingStatus, CliveStoreStatusChip } from '../StatusChip/CliveStoreStatusChip';

interface SummaryCardProps {
  title: string;
  summaryText: string;
  className?: string;
  isCollapsible?: boolean;
  isOpenByDefault?: boolean;
  summaryStatus?: CliveStoreProcessingStatus;
  onCopySummary?: () => void;
}

export const CliveSummaryCard: React.FC<SummaryCardProps> = ({
  title,
  summaryText,
  className,
  isCollapsible = false,
  isOpenByDefault = false,
  summaryStatus = CliveStoreProcessingStatus.SUCCESS,
  onCopySummary,
}) => {
  const titleAction =
    summaryStatus && summaryStatus !== CliveStoreProcessingStatus.SUCCESS ? (
      <CliveStoreStatusChip status={summaryStatus} variant={CliveChipVariant.WHITE} />
    ) : (
      <CliveCopyToClipboardButton
        textToCopy={summaryText}
        onCopy={onCopySummary}
        ariaLabel={`Copy ${title.toLowerCase()}`}
      />
    );

  const effectiveIsCollapsible =
    isCollapsible && (summaryStatus ? summaryStatus === CliveStoreProcessingStatus.SUCCESS : true);

  return (
    <CardBase
      paddingX={24}
      paddingY={20}
      contentGap={5}
      shadow={false}
      border={true}
      titleProps={{
        variant: 'LG',
        weight: 'SEMI_BOLD',
        colorVariant: 'PRIMARY',
      }}
      title={<Heading className="text-base text-aiV2-darkBlue">{title}</Heading>}
      titleAction={titleAction}
      collapsible={effectiveIsCollapsible}
      openByDefault={isOpenByDefault}
      className={cn(className, 'border-blue-100 bg-white')}
    >
      <div className="m-0 max-h-[450px] overflow-y-auto p-0">
        <MarkdownSection markdown={summaryText} className="px-0 pt-0 text-base font-normal text-aiV2-darkerBlue" />
      </div>
    </CardBase>
  );
};
export default CliveSummaryCard;
